// export const base_url = 'https://mied.brandmarks360.com/api';
export const base_url = 'https://admin.miedeg.com/api';